import { render, staticRenderFns } from "./RewardsSummary.vue?vue&type=template&id=23874718&scoped=true"
import script from "./RewardsSummary.vue?vue&type=script&lang=js"
export * from "./RewardsSummary.vue?vue&type=script&lang=js"
import style0 from "./RewardsSummary.vue?vue&type=style&index=0&id=23874718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23874718",
  null
  
)

export default component.exports